/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIResponseError } from './APIResponseError';
import {
    APIResponseErrorFromJSON,
    APIResponseErrorFromJSONTyped,
    APIResponseErrorToJSON,
    APIResponseErrorToJSONTyped,
} from './APIResponseError';
import type { PostAttestationV3Resp } from './PostAttestationV3Resp';
import {
    PostAttestationV3RespFromJSON,
    PostAttestationV3RespFromJSONTyped,
    PostAttestationV3RespToJSON,
    PostAttestationV3RespToJSONTyped,
} from './PostAttestationV3Resp';
import type { APIMeta } from './APIMeta';
import {
    APIMetaFromJSON,
    APIMetaFromJSONTyped,
    APIMetaToJSON,
    APIMetaToJSONTyped,
} from './APIMeta';

/**
 * 
 * @export
 * @interface PostAttestationV3200Response
 */
export interface PostAttestationV3200Response {
    /**
     * 
     * @type {APIMeta}
     * @memberof PostAttestationV3200Response
     */
    meta?: APIMeta;
    /**
     * 
     * @type {Array<APIResponseError>}
     * @memberof PostAttestationV3200Response
     */
    errors?: Array<APIResponseError>;
    /**
     * 
     * @type {PostAttestationV3Resp}
     * @memberof PostAttestationV3200Response
     */
    result?: PostAttestationV3Resp;
}

/**
 * Check if a given object implements the PostAttestationV3200Response interface.
 */
export function instanceOfPostAttestationV3200Response(value: object): value is PostAttestationV3200Response {
    return true;
}

export function PostAttestationV3200ResponseFromJSON(json: any): PostAttestationV3200Response {
    return PostAttestationV3200ResponseFromJSONTyped(json, false);
}

export function PostAttestationV3200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostAttestationV3200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'meta': json['meta'] == null ? undefined : APIMetaFromJSON(json['meta']),
        'errors': json['errors'] == null ? undefined : ((json['errors'] as Array<any>).map(APIResponseErrorFromJSON)),
        'result': json['result'] == null ? undefined : PostAttestationV3RespFromJSON(json['result']),
    };
}

export function PostAttestationV3200ResponseToJSON(json: any): PostAttestationV3200Response {
    return PostAttestationV3200ResponseToJSONTyped(json, false);
}

export function PostAttestationV3200ResponseToJSONTyped(value?: PostAttestationV3200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'meta': APIMetaToJSON(value['meta']),
        'errors': value['errors'] == null ? undefined : ((value['errors'] as Array<any>).map(APIResponseErrorToJSON)),
        'result': PostAttestationV3RespToJSON(value['result']),
    };
}

